import React from 'react';
import './App.css';
import  HomePage from './components/layout/home/home'

  import Navbar from './components/layout/Navigation/navbar'
  import Footer from './components/footer/Footer'

  import { FirebaseDatabaseProvider } from "@react-firebase/database";
import {
  FirebaseAuthProvider,
  FirebaseAuthConsumer,
} from "@react-firebase/auth";
import firebaseConfig from "./firebaseConfig";
import firebase from "firebase/app";


function App() {
  return (
  <div className="App">
      
          <Navbar/>
           <Footer/>
  </div>
  );
}

export default App;
